import axios from 'axios';
import type { ArgsGetProducts, IProduct } from '~/types/products';

const getProducts = async (params: ArgsGetProducts) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products`,
    { headers: { Authorization: token }, params },
  );
  return { products: data.products || [], meta: data.meta };
};

const getProductsList = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/list`,
    { headers: { Authorization: token } },
  );
  return data?.list;
};

const getProduct = async (id: string) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/${id}`,
    { headers: { Authorization: token } },
  );
  return data.product;
};

const createProduct = async (payload: Partial<IProduct>): Promise<{ product: IProduct }> => {
  const token = localStorage.getItem('token');
  const { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/products`,
    payload,
    { headers: { Authorization: token } },
  );
  return data;
};

const updateProduct = async (payload: Partial<IProduct>): Promise<{ product: IProduct }> => {
  const token = localStorage.getItem('token');
  const { _id, ...updatedData } = payload;
  const { data } = await axios.put(
    `${process.env.REACT_APP_API_URL}/products/${_id}`,
    updatedData,
    { headers: { Authorization: token } },
  );
  return data;
};

const deleteProduct = async (id: string): Promise<{ message: string }> => {
  const token = localStorage.getItem('token');
  const { data } = await axios.delete(
    `${process.env.REACT_APP_API_URL}/products/${id}`,
    { headers: { Authorization: token } },
  );
  return data;
};

export {
  getProducts,
  getProductsList,
  getProduct,
  createProduct,
  updateProduct,
  deleteProduct,
};
